/*
 * Japanese texts
 */
export default {
  // v3
  'waiting': '保留中',
  'checking': 'チェック中',
  'processing': 'データ作成中',
  'delivered': '納品済み',
  'archived': 'アーカイブ',
  'rejected': '拒否された',
  'golive': 'ライブへ',
  'Billing': '請求書',
  'Try-on': '試着',
  'Top 10 try-on products': '人気商品ランキング',
  'Try-on count': '試着回数',
  'Try-on time (minutes)': '試着時間（分）',
  'Status': 'ステータス',
  'From': 'から',
  'To': 'まで',
  'Sort by': '並び替え',
  'time(s)': '回',
  'Overview': '概要',
  'Last 24 hours': '最近の24時間',
  'Last 7 days': '最近の7日',
  'Last 30 days': '最近の30日',
  'This year': '今年',
  'All time': 'すべて',
  'Amount until now': '利用料の累計',
  'Web': 'ｳｪｯﾌﾞ',
  'Mobile': 'ﾓﾊﾞｲﾙ',
  'fWeb': 'ウェブ',
  'fMobile': 'モバイル',
  'Total SKU': 'SKUの合計',
  'Add product': '商品を追加',
  'Latest': '新しい順',
  'Oldest': '古い順',
  'Try-on count: ascending': '試着回数：昇順',
  'Try-on count: descending': '試着回数：降順',
  'Created date': '作成した日付',
  'Pay all': 'すべて払い',
  'Date': '日付',
  'Invoice': '請求書',
  'Amount': '合計',
  'On going': '進行中',
  'Paid': '支払い済み',
  'Unpaid': '未払',
  'Drop files here': 'ファイルをここにドロップしてください',
  'or': 'または',
  'Browse files': 'ファイルを選ぶ',
  'All files must be in ".zip" type and follow by below instruction link': 'zip形式のファイルをアップロードしてください（詳細は以下リンク参照）。',
  'Yes, we support upload multiple files at once': '一度に複数のファイルをアップロードできます。',
  'How to capture glasses assets': 'メガネ写真の撮り方とファイル形式について',
  'Please provide SKU code': 'SKUコードを提供してください',
  'Are you sure to request creating glasses?': 'メガネの作成要求しますか？',
  'Files': 'ファイル',
  'Unit price': '単価',
  'Trial': 'トライアル',
  'Product count': '商品数',
  'Notifications': 'お知らせ',
  'Download latest assets': '最新所有をダウンロード',
  'Upload new assets': '新しい所有をアップロード',
  'Upload new assets successfully': '所有がアップロードされました',
  'Billing Report': '請求書のレポート',
  'Details': '詳細',
  'Live try-on usage': 'ライブ試着使用',
  'Data not found': 'データが見つかりません',
  'You have no billings': '請求書がありません。',
  'digital assets have been delivered': '{sku}の商品データが納品されました。',
  'free 25 SKUs': '25 SKUsの無料',
  'Payment': '支払',
  'Copy': 'コピー',
  'CopiedURLParams': 'クエリパラメータをクリップボードにコピーしました。',

  // Filter text translate
  'all': 'すべて',

  // Signup Text Translate
  'SIGN_UP_STEP_1': '新規登録',
  'SIGN_UP_STEP_2' : 'アカウントの認証',
  'SIGN_UP_STEP_3' : 'プロフィールの入力',
  'TERM_AND_PRIVACY_TEXT_1': '新規登録することにより、当社の',
  'TERM_AND_PRIVACY_TEXT_2': '利用契約',
  'TERM_AND_PRIVACY_TEXT_3': 'および',
  'TERM_AND_PRIVACY_TEXT_4': 'プライバシーポリシー',
  'TERM_AND_PRIVACY_TEXT_5': 'に同意したとみなされます。',
  'PASSWORD_STRENGTH_0' : 'パスワード強度',
  'PASSWORD_STRENGTH_1' : '非常に弱い',
  'PASSWORD_STRENGTH_2' : '弱い',
  'PASSWORD_STRENGTH_3' : '普通',
  'PASSWORD_STRENGTH_4' : '強い',
  'PASSWORD_STRENGTH_5' : '非常に強い',
  'ACCOUNT_VERIFICATION' : 'アカウントの認証',
  'CHECK_MAIL_TEXT_1' : ' ',
  'CHECK_MAIL_TEXT_2' : 'に送信したアカウント認証メールをご確認ください。',
  'RESEND_EMAIL_TEXT' : '認証メールを再送する',
  'COMPLETE_PROFILE_1' : '次に、',
  'COMPLETE_PROFILE_2' : 'の設定をしてください。',

  // Upgrade plan Text Translate
  'PLAN_GLASSON_HEADER': 'GlassOn',
  'PLAN_GLASSON_TITLE_LINE_1': 'バーチャル試着で売上アップ、メガネ販売の常識が変わる！',
  'PLAN_GLASSON_TITLE_LINE_2_P1': 'PROプランの全ての機能を30日間無料でお試しいただけます。',
  'PLAN_GLASSON_TITLE_LINE_2_P2': ' ',
  'PLAN_FREE_TITLE': 'FREE',
  'PLAN_PRO_TITLE': 'PRO',
  'PLAN_PRO_FROM': ' ',
  'PLAN_PERMONTH_TEXT': '~ 月額(税別)',
  'PLAN_PRO_CHECK_OUT_DESCRIPTION': '1ヶ月の無料トライアル付き( 2ヶ月目から課金）',
  'PLAN_FREE_JOIN_NOW_BTN': '今すぐ使ってみる',
  'PLAN_PRO_UPGRADE_NOW_BTN': 'PROプランで使ってみる',
  'PLAN_FREE_DESCRIPTION': 'GlassOnの基本的な機能を気軽に使える無料プランです。まずは無料プランで自社商品のバーチャル試着をお試しください。',
  'PLAN_FREE_VIRTUAL_DESCRIPTION' : 'ーチャル試着機能をお',
  'PLAN_PRO_DESCRIPTION': '小規模から大規模のメガネ店舗（チェーン展開）/メガネ店舗/ブランド/メーカー向けまで幅広く対応。GlassOnの全てのバーチャル試着機能をお使いいただけます。',
  'PLAN_SUBCRIPTION_LINE_1_FREE': '5 商品まで登録可能',
  'REGISTER_UP': ' ',
  'PLAN_SUBCRIPTION_LINE_1_VIRTUAL_TEXT': '可能商品数に応じて課金。100商品単位でご購入頂きます。 ( 詳細な料金プランを見る)',
  'PLAN_SUBCRIPTION_LINE_1_PRO': ' 商品まで登録可能商品数に応じて課金。100商品単位でご購入頂きます。',
  'PLAN_SUBCRIPTION_LINE_1_PRO_REFER_TO': ' ',
  'PLAN_SUBCRIPTION_LINE_1_PRO_PRICE_DETAIL': '詳細な料金プランを見る',
  'PLAN_SUBCRIPTION_LINE_2': '登録した自社商品のGlassOnアプリでのバーチャル試着',
  'PLAN_SUBCRIPTION_LINE_3_P1': ' 試着ボタン用の埋込みWebリンクの発行',
  'PLAN_SUBCRIPTION_LINE_3_P2': '（GlassOnアプリへの誘導）',
  'PLAN_SUBCRIPTION_LINE_4_P1': '試着用のQRコードの生成',
  'PLAN_SUBCRIPTION_LINE_4_P2': '（GlassOnアプリへの誘導）',
  //'PLAN_SUBCRIPTION_LINE_5': 'Support 2D Glasses Data',
  'PLAN_SUBCRIPTION_LINE_6': '自社商品をGlassOnアプリ上のショップリストに公開',
  'PLAN_FREE_FOOTER_TITLE': 'いつでもPROに変更できます',
  'PLAN_PRO_FOOTER_TITLE': 'Boost your sales by GlassOn!',
  'PLAN_FREE_TEXT': 'FREE',
  'SELECTED_PLAN': '現在のプラン',
  'SUPPORT_TEXT': 'GlassOnに登録する2Dメガネデータの作成をオプション(別料金)で承ります。',
  'CONTACT_US_TEXT_1': '(詳しくは',
  'CONTACT_US_TEXT_2': 'お問い合わせ',
  'CONTACT_US_TEXT_3': 'ください。)',
  'PLAN_DOWNGRADE_BTN': 'ダウングレード',
  'BOOST_YOUR_BUSINESS': 'Boost your sales by GlassOn!',

  // Check out Text Translate
  'CHECK_OUT_UPDATE_PLAN': '新しいプラン',
  'CHECK_OUT_PRODUCT_PACK': '商品を登録',
  'CHECK_OUT_UPDATE_PLAN_COL_1': 'プラン名',
  'CHECK_OUT_UPDATE_PLAN_COL_2': 'Your next bill estimation at ',
  'CHECK_OUT_UPDATE_PLAN_COL_3': 'Your monthly bill estimation after ',
  'CHECK_OUT_YOUR_MONTHLY_BILL': '月額料金',
  'CHECK_OUT_FREE_PLAN': 'Free',
  'CHECK_OUT_CURRENT_PLAN': '現在のプラン',
  'CHECK_OUT_CURRENT_PLAN_COL_1': 'プラン名',
  'CHECK_OUT_CURRENT_PLAN_COL_2': 'Your next bill',
  'CHECK_OUT_PAYPAL_INFO': 'PayPalへ通知する情報 (＊PayPalでのお支払いには以下の情報を通知する必要があります。)',

  // Profile Text Translate
  'PROFILE_TITLE': 'プロフィール',
  'PROFILE_GENERAL_TAB': '基本情報',
  'PROFILE_CHANGE_PASS_TAB': 'パスワードの変更',
  'PROFILE_STORE_NAME': 'ストア名',
  'PROFILE_NAME': 'ストア名',
  'PROFILE_DESCRIPTION': '説明',
  'PROFILE_HOMEPAGE': 'ウェブサイト',
  'PROFILE_WEBSITE': 'ウェブサイト',
  'PROFILE_ADDRESS': '住所',
  'PROFILE_ADDRESS_LINE_1': '住所１',
  'PROFILE_ADDRESS_LINE_2': '住所２（ビル名など）',
  'PROFILE_CONTACT_EMAIL': 'メールアドレス',
  'PROFILE_PHONE': '電話番号',

  // Price Detail Text Translate
  'PRICE_DETAIL_TITLE': '価格の詳細',
  'PRICE_DETAIL_PRO_PLAN_TITLE': 'PROプラン：100商品毎の単価表',
  'PRICE_DETAIL_PRO_PLAN_CURRENCY': '通貨',
  'PRICE_DETAIL_PRO_PLAN_DESCRIPTION': '＊100商品単位でご購入いただきます。',
  'PRICE_DETAIL_PRO_PLAN_COL_1': '登録する商品数',
  'PRICE_DETAIL_PRO_PLAN_COL_2': '100商品毎の価格',
  'PRICE_DETAIL_PRO_PLAN_COL_3': '６～3００',
  'PRICE_DETAIL_PRO_PLAN_COL_4': '３０１以上',
  'PRICE_DETAIL_PRO_PLAN_COL_5': '合計料金',
  'PRICE_DETAIL_PRO_PLAN_EXAMPLE_TEXT': '商品数に応じた料金の例',

  'PRICE_DETAIL_SUBCRIPTION_TEXT': '月額料金の計算に関する詳細',
  'PRICE_DETAIL_SUBCRIPTION_LINE_1': 'PROプランにご登録いただいた日から30日間は無料でご利用いただけます。',
  'PRICE_DETAIL_SUBCRIPTION_LINE_2': 'お支払日について：無料期間の終了日から30日ごとに当月分の料金をお支払いいただきます。PROプランの商品数の追加/削減を変更した場合は、変更日から起算して30日ごとにお支払日が変更されます。',
  'PRICE_DETAIL_SUBCRIPTION_LINE_3': 'PROプランの商品数の追加/削減、PROプランからFreeプランへの変更はいつでもできます。以下の注意事項にお読みください。',
  'PRICE_DETAIL_SUBCRIPTION_LINE_4': '注意事項:',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_1': 'プランへの変更日に、変更した日までのPROプラン料金を日割りでお支払いいただきます。',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_1_IMP': ' ',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_2': 'PROプランの商品数を削減、もしくはPROプランからFreeプランへ変更した場合、新しいご登録数以上の商品データは、プラン変更後5日間は「削除準備中」のステータスとなります。「削除準備中」の間に再度PROプランの商品数を追加、もしくはFreeプランからPROプランへ変更した場合、「削除準備中」は解除され、それらの商品データを引き続きご利用可能です。',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_3': '新しいPROプランの商品数が前回より少ない場合は、登録日の新しい100商品が引き続きご利用可能です。残りの商品データは、更に5日後に削除されます。',
  //'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_TEXT': 'Ex: Begin register 100 products on January 5th. After that upgrade to 400 products on next February 20th. After that downgrade to 300 products on next May 15th.',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_1': 'イベント',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_2': '期日',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_3': '発生する料金',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_4': '備考',

  'SUBCRIPTION_EX': '例: 以下のようにご利用プランを変更された場合の料金について',
  'SUBCRIPTION_EX_LINE_1': '1月5日にPROプラン(300商品)をご利用開始。',
  'SUBCRIPTION_EX_LINE_2': '3月20日にPROプランからFreeプランに変更手続き。',
  'SUBCRIPTION_EX_LINE_3': 'その後、3月24日にPROプラン：100商品へご変更頂いた場合。',

  'EXPLAIN_LINE_1': 'PROプラン300商品に登録',
  'EXPLAIN_LINE_2': 'お支払い(PROプラン300商品:1回目)',
  'EXPLAIN_LINE_3': 'お支払い(PROプラン300商品:2回目)',
  'EXPLAIN_LINE_4': 'PROプランからFreeプランに変更',
  'EXPLAIN_LINE_5': '再度、PROプラン100商品へ変更',
  'EXPLAIN_LINE_6': 'お支払い(PROプラン100商品:1回目)',
  'EXPLAIN_LINE_7': 'お支払い(PROプラン100商品:2回目)',
  'EXPLAIN_LINE_8': 'お支払い(PROプラン100商品:3回目)',
  'NOTE_LINE_1': '1ヶ月の無料トライアル適用',
  'NOTE_LINE_2': '1ヶ月分の料金(300商品)',
  'NOTE_LINE_3': '3/6から3/20までの日割り料金(300商品)',
  'NOTE_LINE_4': '1ヶ月分の料金(100商品)',
  'SUB_NOTE_LINE_1': '*300商品は「削除準備中」のステータスとなります。',
  'SUB_NOTE_LINE_2': '*登録日の新しい100商品が通常のステータスに戻ります。',
  'SUB_NOTE_LINE_3': '*残りの200商品は5日後(3月28日)に削除されます。',
  'PRODUCT_PRICE': 'Product price',
  'FREE_DURATION': 'Free duration',
  'UPPER': 'upper',
  'TO': ' ',

  'DASHBOARD': 'ダッシュボート',
  'ANALYTICS': 'アナリティクス',
  'PAYMENT_REPORT': '支払レポート',
  'PRODUCT_LIST': '商品一覧',
  'CONTACT_US': '問い合わせ',
  'UPLOAD_STEP_1': 'メガネ情報の入力',
  'UPLOAD_STEP_2': 'メガネデータの登録',
  'GENERAL_INFORMATION': 'メガネ情報',
  'SKU': '商品名(SKU)',
  'kids': 'キッズ',
  'other': 'その他',
  'GLASSES_TYPE': 'タイプ',
  'eyeglasses': 'メガネ',
  'sunglasses': 'サングラス',
  'sportglasses': 'スポーツグラス',
  'FRAME_TYPE': 'フレームタイプ',
  'full_frame': 'フルフレーム',
  'rimless': 'ツーポイント',
  'semi_rimless': 'ハーフリム',
  'FRAME_SHAPE': 'フレーム形状',
  'rectangle': 'レクタングル',
  'square': 'スクエア',
  'wayframe': 'ウェイフレーム',
  'oversized': 'オーバーサイズ',
  'oval': 'オーバル',
  'wrap': 'ラップ',
  'aviator': 'アビエーター',
  'cateye': 'キャットアイ',
  'round': 'ラウンド',
  'browline': 'ブロー',
  'geometric': 'ジオメトリック',
  'butterfly': 'バタフライ',
  'wellington': 'ウェリントン',
  'boston': 'ボストン',
  'nose_pad': '鼻パット付き',
  'resin': 'レジン',
  'celluloid': 'セルロイド',
  'titanium': 'チタン',
  'stainless': 'ステンレス',
  'PUBLIC_MODE_TITLE': 'GlassOnアプリのストアリストに公開する',
  'LOCALE_INFORMATION': 'ロケール情報',
  'SELECT_LOCALE': 'ロケールの選択',
  'LINK_TO_PRODUCT_WEBSITE': '商品のWebサイト',
  'URL': '商品のWebサイト',
  'NOTE': '商品の説明',
  'Next': '次へ',

  'Name': 'お名前',
  'EmailAddress': 'メールアドレス',
  'Subject': '件名',
  'Content': 'お問い合わせ内容',
  'Send': '送信する',

  'Menu': 'メニュー',
  'Dashboard': 'ダッシュボート',
  'Analytics': 'アナリティクス',
  'PaymentReport': '支払レポート',
  'ProductList': '商品一覧',
  'LensList': 'LensList',
  'ContactUs': '問い合わせ',

  'Top10': '商品ダウンロードトップ10',
  'NumberOfDownloads': 'ダウンロード数',
  'NumberOfDownloads_1byte': 'ﾀﾞｳﾝﾛｰﾄﾞ数',
  'SaveQRcode': 'QRコードを保存する',

  'StartContract': '契約開始日',
  'EndContract': '契約解除日',
  'RegisteredProductPack': '登録された商品パック',
  'TotalAmount': '合計',

  'TermOfService': '利用規約',
  'PrivacyPolicy': 'プライバシーポリシー',
  'ServiceLevelAgreement': 'サービスレベル契約',

  'Modify': 'プラン変更',
  'ConsumedProducts': '登録済み商品数',

  'DOWNGRADE_TITLE': 'ダウングレードの前に以下を必ずご確認ください。',
  'DOWNGRADE_WAITING_FOR_REMOVE': '削除準備中',
  'DOWNGRADE_LINE1_1': '1. Freeプランに変更後、登録日の新しい5商品以外は「',
  'DOWNGRADE_LINE1_2': '」のステータスに変更されます。',
  'DOWNGRADE_LINE2_1': '2. 「',
  'DOWNGRADE_LINE2_2': '」の商品は5日後に自動的に削除されます。',
  'DOWNGRADE_LINE3': '3. 必要に応じて、5日以内にデータのバックアップをお客ご自身で行ってください。',
  'DOWNGRADE_LINE4_1': '4. 5日以内に再度PROプランにご変更頂いた場合、「',
  'DOWNGRADE_LINE4_2': '」の商品も元の通り復旧されます(登録したPROプランの商品数の範囲内に限る。)',
  'DOWNGRADE_LINE5_1': '5. ご不明な点は「',
  'DOWNGRADE_LINE5_2': '」をご確認ください。',
  'DOWNGRADE_NOTE_1': 'ご注意：ダウングレードの際、本日までのご利用料金',
  'DOWNGRADE_NOTE_2': 'をお支払い頂きます。',
  'DOWNGRADE_NOTE_UNPAID': '試用期間中のダウングレードプランのために支払う必要はありません。',
  'DOWNGRADE_ASK': '確認のため、以下に "Downgrade" と入力してください。',

  'URL_INVALID': 'URLが無効です',
  'PHONE_INVALID': '電話番号が無効です',
  'ACCOUNT_VERIFIED_SUCCESS': 'あなたのアカウントは正常に確認されました。',

  'Prev': '前',
  'WILL_BE_REMOVED_ON': 'に削除されます',
  'SAMPLE_DATA': 'サンプルデータ',

  'CHECKOUT_LINE1_1': '新しいプランは【',
  'CHECKOUT_LINE1_2': '】です。',
  'CHECKOUT_LINE2_1': '次回のお支払日／金額は',
  'CHECKOUT_LINE2_2': '、',
  'CHECKOUT_LINE2_3': 'の予定です。',

  'PAYMENT_REPORT_CURRENT_PLAN': '現在のプラン',
  'PAYMENT_REPORT_CURRENT_PLAN_PRODUCT': '商品',
  'PAYMENT_REPORT_START_FROM': 'ご利用開始日',
  'PAYMENT_REPORT_NEXT_PAYMENT_ON': '次回のお支払日',
  'PAYMENT_REPORT_AMOUNT': 'お支払金額',
  'PAYMENT_REPORT_TRIAL_PERIOD_STATUS': '残りの無料期間',
  'PAYMENT_REPORT_TRIAL_PERIOD_STATUS_DAY': '日',
  'PAYMENT_REPORT_PRODUCT': '商品 ',
  'PAYMENT_REPORT_MONTHLY_BILL': '月額料金',

  'LENS_WIDTH': 'レンズの幅',
  'LENS_HEIGHT': 'レンズの高さ',

  'BRAND_NAME': 'ブランド名',
  'Search': '探す',
  'EXPORT_CSV': 'CSVをエクスポート(選択したSKU)',
  'IMPORT_CSV': 'CSVインポート',
  'EXPORT_ALL_DATA': 'CSVをエクスポート(全てのSKU)',
  'IMPORT_FAILED_TITLE': 'データ形式は間違っています。データをもう一度チェックしてください。',
  'Import': 'インポート',
  'IMPORT_CONFIRMATION_TITLE': 'このデータをインポートしますか？',
  'ARCHIVE_VOLUME_RESTRICTION_MSG': '(アーカイブファイルの容量は5MB以下であるべきです)',
  'ARCHIVE_VOLUME_RESTRICTION_MSG_2': '(各画像の最大解像度は2000x2000以下です)',

  'DESCRIPTION_LENGTH_RESTRICTION': '最大入力可能文字数は半角4,096文字です',
  'COMPANY_NAME': '会社名',
  'SHOP_LOCALE': '店舗ロケール',
  'SHOP_LOCATION': '店舗の場所',
  'SAMPLE_CODE': 'サンプルコード',
  'BASIC_USAGE': '簡易な利用方法',
  'BASIC_HOWTO': '以下の<iframe>を埋め込むと標準の試着ボタン（商品ダウンロードへのリンク付き）を表示します。PCブラウザの場合はQRコードも表示します。',
  'ADVANCED_USAGE': '高度な利用方法',
  'ADVANCED_HOWTO': 'お好みの試着ボタンを使用したい場合はサンプルコードを参考にして以下の直接リンクを<a href>に指定してください。',
  'LINKED_PRODUCT': 'リンクされた商品数：',
  'LINK_TO_PRODUCT_LOCALE': '新しいロケールを作成する',
  'HOWTO_GLOBAL_MODE': 'すべてのロケールで商品を表示したい場合はチェックしてください',
  'GUIDELINE_LOCALE': '商品の「ロケール情報」に使用する店舗の場所、言語、通貨の組合せをここで作成してください。',
  'DOWNLOAD_TEMPLATE': 'CSVテンプレートのダウンロード',
  'SIZE_SETTING_GUIDELINE': '* メガネサイズをボクシングシステムに準拠させました。',
  'EDIT_TIPS': 'ヒント: ▲ ▼ ◀ ▶ ➖ ➕ ボータンを押すとメガネのパーツ分を移動したり、リサイズします',

  // Country code
  'JP': '日本',
  'SG': 'シンガポール',
  'CN': '中国',
  'TW': '台湾',
  'TH': 'タイ',
  'KH': 'カンボジア',
  'PH': 'フィリピン',
  'AU': 'オーストラリア',
  'MY': 'マレーシア',
  'VN': 'ベトナム',
  'ID': 'インドネシア',
  'RU': 'ロシア',
  'IN': 'インド',
  'US': 'アメリカ',
  'GB': '英国',
  'DE': 'ドイツ',
  'IT': 'イタリア',
  'FR': 'フランス',
  'ES': 'スペイン',

  // Language code
  'Language': '言語',
  'ja': '日本語',
  'en': '英語',
  'zh': '中国語',
  'th': 'タイ語',
  'km': 'クメール語',
  'vi': 'ベトナム語',
  'id': 'インドネシア語',
  'ru': 'ロシア語',
  'hi': 'ヒンディー語',
  'de': 'ドイツ語',
  'it': 'イタリア語',
  'fr': 'フランス語',
  'es': 'スペイン語',

  // Currency code
  'JPY': 'JPY - 円',
  'SGD': 'SGD - シンガポールドル',
  'CNY': 'CNY - 元',
  'THB': 'THB - タイバーシ',
  'USD': 'USD - アメリカドル',
  'PHP': 'PHP - フィリピンペソ',
  'AUD': 'AUD - オーストラリアンドル',
  'MYR': 'MYR - マレーシアンリンギット',
  'VND': 'VND - ベトナムドン',
  'IDR': 'IDR - ルピア',
  'RUR': 'RUR - ロシアンルールプ',
  'RUB': 'RUB - ロシアンルールプ',
  'INR': 'INR - インディプッピー',
  'GBP': 'GBP - ポンド',
  'EUR': 'EUR - ユーロ',

  // Lazy translated text
  'Email': 'メールアドレス',
  'ContactEmail': 'Contact Email',
  'Emailisinvalid': 'メールアドレスが無効です',
  'Password': 'パスワード',
  'Passwordisinvalid': 'パスワードが無効です',
  'LOGIN': 'ログイン',
  'Login': 'ログイン',
  'Signup': '新規登録',
  'Forgotyourpassword?': 'パスワードを忘れましたか？',
  'Shopname': 'ストア名',
  'Confirmpassword': 'パスワード確認',
  'Byclickingonsignupyouagreetoourtermsandprivacypolicy.': '新規登録をクリックすると利用規約およびプライバシーポリシーに同意したことになります。',
  'NamemustNOTbeempty': '氏名欄は必ず記入してください',
  'Confirmpasswordisnotmatchedwithpassword': 'パスワードが一致しません',
  'Notice': '注意',
  'Youraccounthasbeenregisteredsuccessfully.': '新しいアカウントが正常に登録されました。',
  'Pleasecheckyouremailtoverifythisaccount.': 'アカウントを確認するにはメールをチェックしてください。',
  'Enteryouremailaddressthatyouusedtoregister.Wellsendyouanemailwithyourusernameandalinktoresetyourpassword.': '登録時に使用したメールアドレスを入力してください。パスワードの再設定のため、ユーザーネームとリンクを載せたメールをお送りします。',
  'ConfirmEmail': 'メールアドレス確認',
  'Anemailhasbeensendto': 'メールを',
  '.Pleasecheckforanemailfromusandclickontheincludedlinktoresetyourpassword.': 'にお送りしました。メールをチェックし、リンクをクリックしてパスワードを再設定してください。',
  'ResetPassword': 'パスワードの再設定',
  'Yourpasswordhasbeenresetsuccessfully.': 'パスワードは再設定されました。',
  'Gender': '性別',
  'male': 'メンズ',
  'female': 'レディース',
  'Birthday': '生年月日',
  'Day': '日',
  'Month': '月',
  'Year': '年',
  'Introduction': '紹介',
  'Description': '説明',
  'Website': 'ウェブサイト',
  'Createddate': '作成日',
  'Address': '住所',
  'Phone': '電話番号',
  'Room': '部屋',
  'Floor': '階層',
  'Building': '建物',
  'Save': '保存',
  'Edit': '編集',
  'Cancel': 'キャンセル',
  'Oldpassword': '旧パスワード',
  'Newpassword': '新規パスワード',
  'Yourpasswordhasbeenupdated': 'パスワードが更新されました',
  'General': '基本情報',
  'ChangePassword': 'パスワードの変更',
  'Yourprofilehasbeenupdated': 'プロフィールが更新されました',
  'Free': '無料',
  'Gold': 'ゴールド',
  'Enterprise': 'エンタープライズ',
  'GetGold': 'ゴールドユーザーになる',
  '¥9,980/monthlysubscription': '購読料9980円／月',
  'Only5glasses': '５つのメガネのみ',
  'Upto100glasses': '最大100個のメガネ',
  'AllowtobuildonGlassOnsite': 'GlassOnのサイトでの組み立てを許可する',
  'Publishglasses': 'メガネを公開する',
  'AllowtopublishglassesproducttostorelistofGlassOnapplication': 'GlassOnアプリ内ストアリストへのメガネ商品の公開を許可する',
  'Highpriority': '優先事項',
  'Higherpriority': '最優先事項',
  'PriorityofappearanceorderinstorelistofGlassOnapplication': 'GlassOnアプリ内ストアリストの表示順序の優先事項',
  'Support': 'サポート',
  'Supportbuildglassesproductfrom3Dmodel': '3Dモデルからのメガネ商品組立をサポートする',
  'SupportmakingdedicateapplicationlikeGlassOnapplication': 'GlassOnアプリのような役に立つアプリの制作をサポートする',
  'SupportmakingECwebsitewithfullARtryonfunction': 'AR試着機能を持つECウェブサイトの制作をサポートする',
  'Registerfree': '無料登録',
  'Upgradeanytime': 'いつでもアップグレード可能',
  'Makeacalltous': '問い合わせ',
  'Entercode': 'コード入力',
  'Haveadiscount?': 'ディスカウントコードをお持ちですか？',
  'Add': '追加',
  'Validdiscountcode': 'ディスカウントコードが確認できました。',
  'Invaliddiscountcode': '不当な割引コード',
  'PAYPAL_GUIDE_1A': 'お支払いには',
  'PAYPAL_GUIDE_1B': 'を使用します。PayPalアカウントをご準備ください。',
  'PAYPAL_GUIDE_2': '「上記で実行する」の次の画面でアカウントを新規作成することもできます。',
  'AddressLine1': '住所１',
  'AddressLine2': '住所２',
  'City': '市町村区',
  'State': '都道府県',
  'ZIPCode': '郵便番号',
  'AddressLine1_Placeholder': '〇〇ビルディング10F',
  'AddressLine2_Placeholder': '〇〇町1-2-3',
  'City_Placeholder': '港区',
  'State_Placeholder': '東京都',
  'ZIPCode_Placeholder': '123-4567',
  'Country': '国',
  'PlaceOrder': '上記で実行する',
  'PaymentExecution': 'お支払いのお手続き',
  'PaymentCancellation': '支払いキャンセル',
  'Congratulations': 'おめでとうございます。',
  'Waitingforcompletingyourtransaction...': '実行中。。。',
  'Yourtransactionisinvalid.': '完了できませんでした。',
  'Yourtransactionhasbeencompleted.': 'お支払いのお手続きが完了しました。',
  'YouarecurrentlyaGolduser.Pleasetryourbestservices.': 'あなた今ゴールドユーザーです。最上のサービスをお楽しみください。',
  'Yourtransactionhasbeencanceled.': '取引がキャンセルされました。',
  'Gotohomepage': 'ホームページへ',
  'Brand': 'ブランド',
  'Material': '材質',
  'Shape': '形状',
  'Size': 'サイズ',
  'Price': '価格',
  'Tryon': '試着',
  'ShowQRcode': 'QRコードを表示する',
  'Nodescriptions': '説明無し',
  'Embed': '埋め込み',
  'Removethisglasses?': 'このメガネを削除しますか？',
  'Removethismodel?': 'このモデルを削除しますか？',
  'Thisshophasntpostedanyglassesyet!': 'このお店はまだメガネを出していません。',
  'OK': 'OK',
  'Delete': '削除',
  'Remove': '除去',
  'Upload': 'アップロード',
  'GlassesList': 'メガネ一覧',
  'Addnewglasses': '新規メガネを追加する',
  'Updateall': 'すべて更新',
  'Youreachthelimitofglassesamount': 'メガネの数の上限に達しました。',
  'Pleaseupgradeyouraccounttogetupto100builtableglasses.': '組み立て可能なメガネの数を100にするにはアカウントをアップグレードしてください。',
  'Updatesuccessful': 'アップデート完了。',
  'Thumbnail': 'サムネイル',
  'Modelname': '商品名',
  'Shortdescription': '簡単な説明',
  'Publicmode': 'パブリックモード',
  'Action': 'アクション',
  'Forembedpurposeaddthislinealongwithyourglasses': '以下のコードをWebサイトに埋め込むと、この商品の試着ボタンを追加できます。',
  'Eye': '目',
  'Bridge': 'ブリッジ',
  'Temple': 'テンプル',
  'Lenscolor': 'レンズの色',
  'Glassessite': 'メガネのサイト',
  'Topublishthisglassesyouneedtoupgradeyouraccount.': 'このメガネを公開するためにはアカウントのアップグレードが必要です。',
  'Upgrade': 'アップグレード',
  'Editglasses': 'メガネを編集',
  'Tellusyourglassesname': 'あなたのメガネの名前を教えて下さい',
  'Thisfieldcannotbeblank': 'ここは空欄ではいけません。',
  'unisex': 'ユニセックス',
  'metal': 'メタル',
  'plastic': 'プラスチック',
  'metal_plastic': 'メタルとプラスチック',
  'Linktostorewebsite': 'お店のサイトへのリンク',
  'Resettoclearcolor': '透明にリセットする',
  'Glassesparts': 'メガネのパーツデータ',
  'Editglassesparts': 'メガネのパーツデータを編集',
  'Youmissedfilesinarchive': 'アーカイブ内のファイルを見落としています',
  'Requiredanarchiveincludingthesefiles': '以下の名前のファイルを含む圧縮ファイルが必要です',
  'Reset': 'リセット',
  'Detail': '詳細',
  'Profile': 'プロフィール',
  'Logout': 'ログアウト',
  'Yourglasseshasbeenupdated': 'メガネデータが更新されました',
  'Showallglasses': 'メガネ一覧を表示する',
  'Checkout': 'お支払いのお手続き',
  'Total': '合計',
  'Monthlysubscription': '月額(税別)',
  'Freescript': 'GlassOnの基本的な機能を気軽に使える無料プランです。まずは無料プランで自社商品のバーチャル試着をお試しください。',
  'Goldscript': '小規模・中規模のメガネ店舗/ブランド/メーカー向け。GlassOnの全てのバーチャル試着機能をお使いいただけます（最初の1ヶ月は無料）。',
  'Enterprisescript': '大規模のメガネ店舗（チェーン展開）/ブランド/メーカー向け。GlassOnをベースとしたオリジナルのバーチャル試着付きアプリやネットショップ制作にも対応します。',
  'Register': ' ',
  'Glassesmodel': '商品まで登録可能',
  'Unlimited': '無制限',
  'Glassesmode2': 'に登録可能',
  'Item1': '試着ボタン用の埋込みWebリンクの発行（GlassOnアプリへの誘導）',
  'Item2': '試着用のQRコードの生成（GlassOnアプリへの誘導）',
  'Item3': '2Dのメガネデータへの対応',
  'Item4': '3Dのメガネデータへの対応<br />* 詳細はお問い合わせください',
  'Item5': '自社商品をGlassOnアプリ上のショップリストに公開',
  'Item6': '2D/3Dデータの作成代行<br /><span class="text-danger">（オプション:別料金）</span>',
  'Item7': '自社ブランド専用の試着機能付きのスマホアプリ、タブレットアプリの作成',
  'Item8': '自社ブランド専用の試着機能付きのネットショップやWebサイトの作成',
  'Discount': '1ヶ月の無料トライアル付き（2ヶ月目から課金）',
  'Contactus': 'お問い合わせ<br />ください',
  'Contractbase': ' ',
  'PromotionPrice': 'プロモーション価格',
  'Downloadsample': 'サンプルデータのダウンロード',

  // Thema
  'clipon': 'クリップ-オン',
  '3dacetate': '3D Acetate',
  'acetate': 'Acetate',
  'combined': 'Combined',
  'metal': 'Metal',
  'titanium': 'Titanium',
  'tr-90': 'TR-90',
  'ultem': 'Ultem',
  'black': 'Black',
  'blue': 'Blue',
  'brown': 'Brown',
  'cream': 'Cream',
  'gold': 'Gold',
  'gray': 'Gray',
  'green': 'Green',
  'orange': 'Orange',
  'pink': 'Pink',
  'red': 'Red',
  'violet': 'Violet',
  'white': 'White',
  'yellow': 'Yellow',
  'gunmetal': 'Gunmetal',
  'havana': 'Havana',
  'metal': 'Metal',
  'multicolor': 'Multi-color',
  'pattern': 'Pattern',
  
  'Store List': 'ストア',
  'Delegate List': 'ストア',
  'Owner': 'オーナー',
  'Archive': 'アーカイブ',
  'PD Measurement': 'PD測定',
  'Model type': 'モデル種別',
  'Add store': 'ストアを追加',
  'Add store successfully': 'ストアを追加しました。',
  'Owner product count': '自分がオーナーの商品数',
  'Shared product count': '共有された商品数',
  'Product setting': 'ストアの商品管理',
  'Available SKUs': '利用可能な全商品',
  'Owner SKUs': '自分がｵｰﾅｰの商品',
  'Shared SKUs': '共有された商品',
  'Owner setting': 'オーナー設定',
  'Share with this store': 'このストアに共有する',
  'View bill list': '請求書を見る',
  'Delete store': 'ストアの削除',
  'Are you sure to delete?': '削除してもいいですか？',
  'Product Group': '商品グループ',
  'Group name': 'グループ名',
  'Group not found': 'グループが見つかりません',
  'Add group': 'グループの追加',
  'Prioritize the model type you want to use': '使用するモデル種別を選択する',
  'Use this iframe for glasses try-on': 'バーチャル試着用のiframeコード',
  'Use this iframe for 360 degree glasses view': '３６０度ビューアー用のiframeコード',
  'GO TESTING': 'テストする（デモ）',
  'Please fill in your store name': 'ストア名を入れてください',
  'Password length must be at least 6 characters': 'パスワードは６文字以上必要です',
  'Confirm password': 'パスワードの確認',
  'Confirm password not match': 'パスワードが一致しません',
  'Unarchive': '納品済みに戻す',
  'Business name': '事業名称（会社名等）',
  'Domain whitelist': '信頼しているドメイン',
  'Domain whitelist (separated by comma)': '信頼しているドメイン(カンマで区切る)',
  'Frame color': 'フレームカラー',
  'SKU: A-Z': '商品名：昇順(SKU:A-Z)',
  'SKU: Z-A': '商品名：降順(SKU:Z-A)',
  'Usage count': '利用回数',
  'Try-on builder': 'トライオンビルダー',
  'PD Measurement Dashboard': 'PD Measurement Dashboard',
  'PD Measurement Integration Guideline': 'PD Measurement Integration Guideline',
  'Overview': 'Overview',
  'Domain Whitelist': 'Domain whitelist',
  'Integration Code': 'Integration code',
  'Demo (for reference only)': 'Demo (for reference only)',
  'Start free trial': 'Start free trial',
  'Get a quote': 'Get a quote',
}



// WEBPACK FOOTER //
// ./routes/app/intl/ja.js